import type { OptionContractWithSnapshot } from "../../hooks/useGetOptionsData";

/** Which side of the quote a leg was selected from. */
export type LegQuoteSide = "bid" | "ask";

/**
 * One option leg on an order ticket. Shape mirrors TradeV2's `SelectedContract`
 * so the pricing/intent helpers we reuse stay compatible.
 */
export interface OrderLeg {
  contract: OptionContractWithSnapshot;
  price: number | undefined;
  quoteSide: LegQuoteSide;
}

/** Max option legs on a single ticket (matches TradeV2). */
export const MAX_TICKET_LEGS = 4;
